import React from "react";
import "./EndScreen.css";
import { IoCheckmarkCircle } from "react-icons/io5";
const EndScreen = ({ channelName, examId }) => {
  // Get current date and time for display
  const currentDate = new Date().toLocaleDateString();
  const currentTime = new Date().toLocaleTimeString();

  return (
    <div className="end-screen-container">
      <div className="end-screen-panel">
        <div className="end-screen-header">
          <h2>Proctoring Session Complete</h2>
          <IoCheckmarkCircle className="checkmark-icon" />
        </div>

        <div className="end-screen-content">
          <p className="thank-you-message">
            Thank you for proctoring this exam session.
          </p>

          <div className="session-details">
            <div className="detail-item">
              <span className="detail-label">Exam ID:</span>
              <span className="detail-value">{channelName || examId}</span>
            </div>

            <div className="detail-item">
              <span className="detail-label">Date:</span>
              <span className="detail-value">{currentDate}</span>
            </div>

            <div className="detail-item">
              <span className="detail-label">Time:</span>
              <span className="detail-value">{currentTime}</span>
            </div>
          </div>

          <div className="completion-message">
            <p>
              All session data has been successfully processed and saved. The
              exam has been marked as completed.
            </p>
            <p>You may close this window or browser tab now.</p>
          </div>
        </div>

        <div className="end-screen-footer">
          <div className="footer-logo">Powered by El Carreira Proctoring</div>
        </div>
      </div>
    </div>
  );
};

export default EndScreen;
